export default function translate(i18n, propriete) {
  if (propriete === 'montantTtc') {
    return i18n.t('validationAcompte.montantTtc');
  }
  if (propriete === 'dateAcompte') {
    return i18n.t('validationAcompte.dateAcompte');
  }
  if (propriete === 'modeReglementId') {
    return {
      message: 'validationAcompte.modeReglement',
    };
  }
  if (propriete === 'designation') {
    return i18n.t('validationAcompte.designation');
  }
  if (propriete === 'assistantId') {
    return i18n.t('validationAcompte.assistant');
  }
  if (propriete === 'commercialId') {
    return i18n.t('validationAcompte.commercial');
  }
  return propriete;
}
